
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import "../../../assets/semantic/semantic.min.js";
import { DateService } from "./../../_services/date.service";
import { DemandService } from "../../_services/demand.service";
import { CompanyService } from "../../_services/company.service";
import { PlaceService } from "../../_services/place.service";
import { IMyDpOptions } from "mydatepicker";
import { PlanningService } from "../../_services/planning.service";

import { SendDemandsModalComponent } from "../send-demands-modal/send-demands-modal.component";

interface Demand {
  id: number;
  client_id: number;
  receiver_id: number;
  departure: any;
  arrival: any;
  vehicle: string;
  quantity: number;
  departure_date: string;
  arrival_date: string;
  sell_price: number;
  note: string;
  planned: boolean;
  client: any;
  receiver: any;
  matching_count: number;
  selected?: boolean; // Ajoutez cette ligne
}
@Component({
  selector: "app-demand",
  templateUrl: "./demand.component.html",
  styleUrls: ["./demand.component.css"],
})
  

export class DemandComponent implements OnInit {
  // page param (stored in URL)
  private page_param: string;
  private demands: Demand[] = [];
  private demands_count: number;
  private page_number: number;
  private page_count: number;
  private page_indicators: number[];

  @ViewChild('sendDemandsModal') sendDemandsModal: SendDemandsModalComponent;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    openSelectorOnInputClick: true,
    editableDateField: false,
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: DemandService,
    private company_service: CompanyService,
    private place_service: PlaceService,
    private planning_service: PlanningService,
    private date_service: DateService
  ) {}

  filters = new FormGroup({
    client_id: new FormControl(),
    receiver_id: new FormControl(),
    departure_city: new FormControl(),
    departure_area: new FormControl(),
    departure_country: new FormControl(),
    arrival_city: new FormControl(),
    arrival_area: new FormControl(),
    arrival_country: new FormControl(),
    vehicle: new FormControl(),
    quantity: new FormControl(""),
    departure_date: new FormControl(),
    arrival_date: new FormControl(),
    sell_price: new FormControl(""),
  });

  ngOnInit() {
    // Get the Params..
    this.route.queryParams.subscribe((params) => {
      this.page_param = params["page"] || 1; // Get Page number Param
    });

    this.filters.valueChanges.debounceTime(500).subscribe((value) => {
      // Check Departure & Arrival places Values:
      // If there is a departure_id city, clear the area & country inputs.
      if (value.departure_city) {
        this.filters.patchValue({
          departure_area: null,
          departure_country: null,
        });
      }
      // If there is a departure_id area, clear the country input
      if (value.departure_area) {
        this.filters.patchValue({ departure_country: null });
      }
      // If there is an arrival_id city, clear the area & country inputs
      if (value.arrival_city) {
        this.filters.patchValue({ arrival_area: null, arrival_country: null });
      }
      // If there is an arival area, clear the country input.
      if (value.arrival_area) {
        this.filters.patchValue({ arrival_country: null });
      }

      if (value.departure_date && value.departure_date.formatted)
        this.filters.patchValue({
          departure_date: value.departure_date.formatted,
        });
      if (value.arrival_date && value.arrival_date.formatted)
        this.filters.patchValue({ arrival_date: value.arrival_date.formatted });
      this.router.navigate(["/demands"], { queryParams: { page: "1" } });
      this.refresh();
    });

    this.refresh();
  }
  
  selectAll(event: any) {
    const checked = event.target.checked;
    this.demands.forEach(demand => demand.selected = checked);
  }
  
  anyDemandSelected(): boolean {
    return this.demands && this.demands.some(demand => demand.selected);
  }

  openSendModal(): void {
    const selectedDemands = this.demands.filter(demand => demand.selected);
    //console.log(selectedDemands);
    //Get matchin offers for each demand
    this.sendDemandsModal.openModal(selectedDemands);
  }

  refresh() {
    let params = {};
    Object.assign(params, this.filters.value, { page: this.page_param });
    this.service.getDemands(params).subscribe((response) => {
      this.page_number = parseInt(response.page);
      this.demands_count = parseInt(response.total_count);
      response.demands.forEach(
        function (demand) {
          this.service.getMatchingOffers(demand.id).subscribe((res) => {
            Object.assign(demand, { matching_count: res.total_count });
          });
        }.bind(this)
      );

      this.demands = response.demands;
      this.page_count = Math.ceil(this.demands_count / 25); // Page Count
      // Page Indicators (for ngFor iterations)
      if (this.page_count < 10) {
        this.page_indicators = Array(this.page_count).fill(1);
      } else {
        this.page_indicators = Array(10).fill(1);
      }
    });
  }

  // Previous Page Button
  previousPage() {
    this.router
      .navigate(["/demands"], { queryParams: { page: this.page_number - 1 } })
      .then(
        function () {
          this.refresh();
        }.bind(this)
      );
  }

  // Next Page Button
  nextPage() {
    this.router
      .navigate(["/demands"], { queryParams: { page: this.page_number + 1 } })
      .then(
        function () {
          this.refresh();
        }.bind(this)
      );
  }

  // Go to page n°nb
  toPage(nb: number) {
    this.router.navigate(["/demands"], { queryParams: { page: nb } }).then(
      function () {
        this.refresh();
      }.bind(this)
    );
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/demand/demand.component.ts